<template>
  <section id="SMS" class="section-item">
    <h1>RCS</h1>

    <section id="api-RCS-PostRcsMessages">
      <h2>RCS - {{ $t("title.send_message") }}</h2>
      <p>{{ $t("rcs.send_rcs_message_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/rcs/messages</code></pre>
      </div>
      <div class="code-toggle">
        <button class="json">JSON</button>
        <pre>
          <code class="language-json">{{ json }}</code>
        </pre>

        <h3>{{ $t("general.parameter") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>agent_id</td>
              <td>UUID</td>
              <td>{{ $t("table.agent_id") }}</td>
            </tr>
            <tr>
              <td>data</td>
              <td>Array</td>
              <td>{{ $t("table.rcs_objects_array") }}</td>
            </tr>
            <tr>
              <td>to</td>
              <td>String</td>
              <td>{{ $t("table.recipient_phone_number") }}</td>
            </tr>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.message_type-rcs") }}</td>
            </tr>
            <tr>
              <td>body</td>
              <td>Object</td>
              <td>{{ $t("table.message_body_object") }}</td>
            </tr>
            <tr>
              <td>webhook</td>
              <td>Object</td>
              <td>{{ $t("table.webhook_object") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Body</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>template_id</td>
              <td>UUID</td>
              <td>{{ $t("table.body.template_id") }}</td>
            </tr>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.message_text_content") }}</td>
            </tr>
            <tr>
              <td>media</td>
              <td>Object</td>
              <td>{{ $t("table.media") }}</td>
            </tr>
            <tr>
              <td>card</td>
              <td>Object</td>
              <td>{{ $t("table.card_object") }}</td>
            </tr>
            <tr>
              <td>carousel</td>
              <td>Object</td>
              <td>{{ $t("table.carousel_items_object") }}</td>
            </tr>
            <tr>
              <td>suggestions[]</td>
              <td>Array</td>
              <td>{{ $t("table.body.suggestions") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Card</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>title</td>
              <td>String</td>
              <td>{{ $t("table.card_title") }}</td>
            </tr>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.card_text") }}</td>
            </tr>
            <tr>
              <td>media</td>
              <td>Object</td>
              <td>{{ $t("table.card_media") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>{{ $t("table.carousel") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>buttons</td>
              <td>Array</td>
              <td>{{ $t("table.buttons_array") }}</td>
            </tr>
            <tr>
              <td>cards</td>
              <td>Array</td>
              <td>{{ $t("table.card_objects_array") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Button</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.button_type") }}</td>
            </tr>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.button_text") }}</td>
            </tr>
            <tr>
              <td>phone_number</td>
              <td>String</td>
              <td>{{ $t("table.dial_button_number") }}</td>
            </tr>
            <tr>
              <td>address</td>
              <td>String</td>
              <td>{{ $t("table.location_address") }}</td>
            </tr>
            <tr>
              <td>url</td>
              <td>String</td>
              <td>{{ $t("table.button_link") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Suggestions</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.button_type") }}</td>
            </tr>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.button_text") }}</td>
            </tr>
            <tr>
              <td>phone_number</td>
              <td>String</td>
              <td>{{ $t("table.dial_button_number") }}</td>
            </tr>
            <tr>
              <td>address</td>
              <td>String</td>
              <td>{{ $t("table.location_address") }}</td>
            </tr>
            <tr>
              <td>url</td>
              <td>String</td>
              <td>{{ $t("table.button_link") }}</td>
            </tr>
            <tr>
              <td>title</td>
              <td>String</td>
              <td>{{ $t("table.suggestions.title") }}</td>
            </tr>
            <tr>
              <td>start_time</td>
              <td>Date</td>
              <td>{{ $t("table.suggestions.start_time") }}</td>
            </tr>
            <tr>
              <td>end_time</td>
              <td>Date</td>
              <td>{{ $t("table.suggestions.end_time") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Webhook</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>url</td>
              <td>String</td>
              <td>{{ $t("table.webhook_url") }}</td>
            </tr>
            <tr>
              <td>headers</td>
              <td>Object</td>
              <td>{{ $t("table.request_header") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Success 200</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>scheduled_at</td>
              <td>String</td>
              <td>{{ $t("table.scheduled_send_datetime") }}</td>
            </tr>
            <tr>
              <td>from</td>
              <td>String</td>
              <td>{{ $t("table.message_sender") }}</td>
            </tr>
            <tr>
              <td>messages</td>
              <td>Array</td>
              <td>{{ $t("table.messages_to_send") }}</td>
            </tr>
            <tr>
              <td>id</td>
              <td>String</td>
              <td>{{ $t("table.message_id") }}</td>
            </tr>
            <tr>
              <td>to</td>
              <td>String</td>
              <td>{{ $t("table.message_recipient") }}</td>
            </tr>
            <tr>
              <td>content</td>
              <td>String</td>
              <td>{{ $t("table.message_content") }}</td>
            </tr>
            <tr>
              <td>account_id</td>
              <td>String</td>
              <td>{{ $t("account.account_id") }}</td>
            </tr>
            <tr>
              <td>direction</td>
              <td>String</td>
              <td>{{ $t("table.message_direction") }}</td>
            </tr>
            <tr>
              <td>status</td>
              <td>String</td>
              <td>{{ $t("table.send_status") }}</td>
            </tr>
            <tr>
              <td>channel</td>
              <td>String</td>
              <td>{{ $t("table.sending_channel") }}</td>
            </tr>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.shipping_type") }}</td>
            </tr>
            <tr>
              <td>client_id</td>
              <td>String</td>
              <td>{{ $t("table.client_id") }}</td>
            </tr>
            <tr>
              <td>is_scheduled</td>
              <td>Boolean</td>
              <td>{{ $t("table.scheduled_message") }}</td>
            </tr>
            <tr>
              <td>updated_at</td>
              <td>String</td>
              <td>{{ $t("table.update_datetime") }}</td>
            </tr>
            <tr>
              <td>created_at</td>
              <td>String</td>
              <td>{{ $t("table.creation_datetime") }}</td>
            </tr>
            <tr>
              <td>sent_at</td>
              <td>String</td>
              <td>{{ $t("table.sending_datetime") }}</td>
            </tr>
            <tr>
              <td>error_code</td>
              <td>String</td>
              <td>{{ $t("table.error_code") }}</td>
            </tr>
            <tr>
              <td>error_message</td>
              <td>String</td>
              <td>{{ $t("table.error_message") }}</td>
            </tr>
          </tbody>
        </table>

        <button class="btn02">Sucesso</button>

        <pre>
      <code class="language-json">HTTP/1.1 200 OK
[
{
 "scheduled_at": "2021-07-05 08:32:55",
 "from": "Default",
 "messages": [
   {
      "id": "b4e1d77a69c585c570c7d77782ddb329",
      "from": "Default",
      "to": "5561996426188",
      "content": "{\"content\":\"Teste\"}",
      "account_id": "3d223457-9fd0-48d1-a7e6-bee520ec055c",
      "direction": "outbound",
      "status": "accepted",
      "channel": "rcs",
      "type": "text",
      "client_id": "6460b274-d764-49aa-9889-0e8272bb62e6",
      "scheduled_at": "2021-07-05 08:32:55",
      "is_scheduled": false,
      "updated_at": "2021-07-05 08:32:55",
      "created_at": "2021-07-05 08:32:55",
      "sent_at": "2021-07-05 08:32:55",
      "error_code": null,
      "error_message": null
   }
 ]
}
]</code>
    </pre>

        <button class="btn02">Error-Response</button>
        <pre>
      <code class="language-json">{
"error": "Error message"
}</code>
    </pre>
      </div>
    </section>

    <section id="api-RCS-GetRcsCapabilitiesPhone">
      <h2>RCS - {{ $t("title.get_agent_capabilities") }}</h2>
      <p>{{ $t("rcs.get_agent_capabilities_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/rcs/capabilities/{phone}</code></pre>
      </div>
      <div class="code-toggle">
        <button @click="selectedTab = 'json'" :class="{ active: selectedTab === 'json' }">JSON</button>
        <button @click="selectedTab = 'curl'" :class="{ active: selectedTab === 'curl' }">cURL</button>
        <pre v-if="selectedTab === 'json'">
          <code class="language-json">{
  "agent_id": "00000000-0000-0000-0000-000000000000"
}</code>
        </pre>
        <pre v-if="selectedTab === 'curl'">
          <code class="language-bash">
curl --location --request GET 'https://{{ whitelabel?.api_domain }}/v1/rcs/capabilities/5511999999999' \
-u '[SEU ID]:[SEU TOKEN]'
--header 'Content-Type: application/json' \
--data '{
  "agent_id": "00000000-0000-0000-0000-000000000000"
}'
          </code>
        </pre>

        <h3>{{ $t("general.parameter") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>phone</td>
              <td>String</td>
              <td>{{ $t("table.phone_path_param") }}</td>
            </tr>
            <tr>
              <td>agent_id</td>
              <td>UUID</td>
              <td>{{ $t("table.agent_id") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section id="api-RCS-PostRcsCapabilities">
      <h2>RCS - {{ $t("title.verify_rcs_capabilities") }}</h2>
      <p>{{ $t("rcs.check_rcs_capabilities_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/rcs/capabilities</code></pre>
      </div>
      <div class="code-toggle">
        <button @click="selectedTab = 'json'" :class="{ active: selectedTab === 'json' }">JSON</button>
        <button @click="selectedTab = 'curl'" :class="{ active: selectedTab === 'curl' }">cURL</button>
        <pre v-if="selectedTab === 'json'">
          <code class="language-json">{
  "agent_id": "00000000-0000-0000-0000-000000000000",
  "phones": [
    "5511999999999",
    "5511999999999"
  ]
}</code>
        </pre>
        <pre v-if="selectedTab === 'curl'">
          <code class="language-bash">
curl --location 'https://{{ whitelabel?.api_domain }}/v1/rcs/capabilities' \
-u '[SEU ID]:[SEU TOKEN]'
--header 'Content-Type: application/json' \
--data '{
  "agent_id": "00000000-0000-0000-0000-000000000000",
  "phones": [
    "5511999999999",
    "5511999999999"
  ]
}'
          </code>
        </pre>

        <h3>{{ $t("general.parameter") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>agent_id</td>
              <td>UUID</td>
              <td>{{ $t("table.agent_id") }}</td>
            </tr>
            <tr>
              <td>phones</td>
              <td>Array</td>
              <td>{{ $t("table.phones_e164") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section id="api-RCS-GetRcsTemplates">
      <h2>RCS - {{ $t("title.list_templates") }}</h2>
      <p>{{ $t("general.list_templates_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/rcs/templates</code></pre>
      </div>
      <div class="code-toggle">
        <button class="curl">cURL</button>
        <pre>
        <code class="language-bash">
curl --location --request GET 'https://{{ whitelabel?.api_domain }}/v1/rcs/templates' \
-u '[SEU ID]:[SEU TOKEN]'
--header 'Content-Type: application/json' \
        </code>
      </pre>

        <h3>{{ $t("general.header") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Content-Type</td>
              <td>String</td>
              <td>
                {{ $t("general.content-type") }}
                <span class="app-json">application/json</span>
              </td>
            </tr>
          </tbody>
        </table>

        <h3>Success 200</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>id</td>
              <td>UUID</td>
              <td>{{ $t("general.template_id") }}</td>
            </tr>
            <tr>
              <td>account_id</td>
              <td>UUID</td>
              <td>{{ $t("general.account_id") }}</td>
            </tr>
            <tr>
              <td>name</td>
              <td>String</td>
              <td>{{ $t("rcs.template.name") }}</td>
            </tr>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("rcs.type") }}</td>
            </tr>
            <tr>
              <td>body</td>
              <td>Object</td>
              <td>{{ $t("rcs.body") }}</td>
            </tr>
            <tr>
              <td>created_at</td>
              <td>Datetime</td>
              <td>{{ $t("general.created_at") }}</td>
            </tr>
            <tr>
              <td>updated_at</td>
              <td>Datetime</td>
              <td>{{ $t("general.updated_at") }}</td>
            </tr>
          </tbody>
        </table>

        <button class="btn02">{{ $t("general.success") }}</button>

        <pre>
        <code class="language-json">HTTP/1.1 200 OK
[
  {{ templateResponseJson }}
]</code>
      </pre>

        <button class="btn02">Error-Response</button>
        <pre>
        <code class="language-json">{
  "error": "Error message"
}</code>
      </pre>
      </div>
    </section>

    <section id="api-RCS-GetRcsTemplate">
      <h2>RCS - {{ $t("title.get_template") }}</h2>
      <p>{{ $t("general.get_template_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/rcs/templates/:id</code></pre>
      </div>
      <div class="code-toggle">
        <button class="curl">cURL</button>
        <pre>
        <code class="language-bash">
curl --location --request GET 'https://{{ whitelabel?.api_domain }}/v1/rcs/templates/:id' \
-u '[SEU ID]:[SEU TOKEN]'
--header 'Content-Type: application/json' \
        </code>
      </pre>

        <h3>{{ $t("general.header") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Content-Type</td>
              <td>String</td>
              <td>
                {{ $t("general.content-type") }}
                <span class="app-json">application/json</span>
              </td>
            </tr>
          </tbody>
        </table>

        <h3>Success 200</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>id</td>
              <td>UUID</td>
              <td>{{ $t("general.template_id") }}</td>
            </tr>
            <tr>
              <td>account_id</td>
              <td>UUID</td>
              <td>{{ $t("general.account_id") }}</td>
            </tr>
            <tr>
              <td>name</td>
              <td>String</td>
              <td>{{ $t("rcs.template.name") }}</td>
            </tr>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("rcs.type") }}</td>
            </tr>
            <tr>
              <td>body</td>
              <td>Object</td>
              <td>{{ $t("rcs.body") }}</td>
            </tr>
            <tr>
              <td>created_at</td>
              <td>Datetime</td>
              <td>{{ $t("general.created_at") }}</td>
            </tr>
            <tr>
              <td>updated_at</td>
              <td>Datetime</td>
              <td>{{ $t("general.updated_at") }}</td>
            </tr>
          </tbody>
        </table>

        <button class="btn02">{{ $t("general.success") }}</button>

        <pre>
        <code class="language-json">HTTP/1.1 200 OK
{{ templateResponseJson }}</code>
      </pre>

        <button class="btn02">Error-Response</button>
        <pre>
        <code class="language-json">{
  "error": "Error message"
}</code>
      </pre>
      </div>
    </section>

    <section id="api-RCS-PostRcsTemplate">
      <h2>RCS - {{ $t("title.create_template") }}</h2>
      <p>{{ $t("general.create_template_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/rcs/templates</code></pre>
      </div>
      <div class="code-toggle">
        <button class="json">JSON</button>
        <pre>
          <code class="language-json">{{ createTemplateJson }}</code>
        </pre>

        <h3>{{ $t("general.parameter") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>name</td>
              <td>String</td>
              <td>{{ $t("table.template_name") }}</td>
            </tr>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.message_type-rcs") }}</td>
            </tr>
            <tr>
              <td>body</td>
              <td>Object</td>
              <td>{{ $t("table.message_body_object") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Body</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.message_text_content") }}</td>
            </tr>
            <tr>
              <td>media</td>
              <td>Object</td>
              <td>{{ $t("table.media") }}</td>
            </tr>
            <tr>
              <td>card</td>
              <td>Object</td>
              <td>{{ $t("table.card_object") }}</td>
            </tr>
            <tr>
              <td>carousel</td>
              <td>Object</td>
              <td>{{ $t("table.carousel_items_object") }}</td>
            </tr>
            <tr>
              <td>suggestions[]</td>
              <td>Array</td>
              <td>{{ $t("table.body.suggestions") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Card</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>title</td>
              <td>String</td>
              <td>{{ $t("table.card_title") }}</td>
            </tr>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.card_text") }}</td>
            </tr>
            <tr>
              <td>media</td>
              <td>Object</td>
              <td>{{ $t("table.card_media") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>{{ $t("table.carousel") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>buttons</td>
              <td>Array</td>
              <td>{{ $t("table.buttons_array") }}</td>
            </tr>
            <tr>
              <td>cards</td>
              <td>Array</td>
              <td>{{ $t("table.card_objects_array") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Button</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.button_type") }}</td>
            </tr>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.button_text") }}</td>
            </tr>
            <tr>
              <td>phone_number</td>
              <td>String</td>
              <td>{{ $t("table.dial_button_number") }}</td>
            </tr>
            <tr>
              <td>address</td>
              <td>String</td>
              <td>{{ $t("table.location_address") }}</td>
            </tr>
            <tr>
              <td>url</td>
              <td>String</td>
              <td>{{ $t("table.button_link") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Suggestions</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.button_type") }}</td>
            </tr>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.button_text") }}</td>
            </tr>
            <tr>
              <td>phone_number</td>
              <td>String</td>
              <td>{{ $t("table.dial_button_number") }}</td>
            </tr>
            <tr>
              <td>address</td>
              <td>String</td>
              <td>{{ $t("table.location_address") }}</td>
            </tr>
            <tr>
              <td>url</td>
              <td>String</td>
              <td>{{ $t("table.button_link") }}</td>
            </tr>
            <tr>
              <td>title</td>
              <td>String</td>
              <td>{{ $t("table.suggestions.title") }}</td>
            </tr>
            <tr>
              <td>start_time</td>
              <td>Date</td>
              <td>{{ $t("table.suggestions.start_time") }}</td>
            </tr>
            <tr>
              <td>end_time</td>
              <td>Date</td>
              <td>{{ $t("table.suggestions.end_time") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Webhook</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>url</td>
              <td>String</td>
              <td>{{ $t("table.webhook_url") }}</td>
            </tr>
            <tr>
              <td>headers</td>
              <td>Object</td>
              <td>{{ $t("table.request_header") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Success 200</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>scheduled_at</td>
              <td>String</td>
              <td>{{ $t("table.scheduled_send_datetime") }}</td>
            </tr>
            <tr>
              <td>from</td>
              <td>String</td>
              <td>{{ $t("table.message_sender") }}</td>
            </tr>
            <tr>
              <td>messages</td>
              <td>Array</td>
              <td>{{ $t("table.messages_to_send") }}</td>
            </tr>
            <tr>
              <td>id</td>
              <td>String</td>
              <td>{{ $t("table.message_id") }}</td>
            </tr>
            <tr>
              <td>to</td>
              <td>String</td>
              <td>{{ $t("table.message_recipient") }}</td>
            </tr>
            <tr>
              <td>content</td>
              <td>String</td>
              <td>{{ $t("table.message_content") }}</td>
            </tr>
            <tr>
              <td>account_id</td>
              <td>String</td>
              <td>{{ $t("account.account_id") }}</td>
            </tr>
            <tr>
              <td>direction</td>
              <td>String</td>
              <td>{{ $t("table.message_direction") }}</td>
            </tr>
            <tr>
              <td>status</td>
              <td>String</td>
              <td>{{ $t("table.send_status") }}</td>
            </tr>
            <tr>
              <td>channel</td>
              <td>String</td>
              <td>{{ $t("table.sending_channel") }}</td>
            </tr>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.shipping_type") }}</td>
            </tr>
            <tr>
              <td>client_id</td>
              <td>String</td>
              <td>{{ $t("table.client_id") }}</td>
            </tr>
            <tr>
              <td>is_scheduled</td>
              <td>Boolean</td>
              <td>{{ $t("table.scheduled_message") }}</td>
            </tr>
            <tr>
              <td>updated_at</td>
              <td>String</td>
              <td>{{ $t("table.update_datetime") }}</td>
            </tr>
            <tr>
              <td>created_at</td>
              <td>String</td>
              <td>{{ $t("table.creation_datetime") }}</td>
            </tr>
            <tr>
              <td>sent_at</td>
              <td>String</td>
              <td>{{ $t("table.sending_datetime") }}</td>
            </tr>
            <tr>
              <td>error_code</td>
              <td>String</td>
              <td>{{ $t("table.error_code") }}</td>
            </tr>
            <tr>
              <td>error_message</td>
              <td>String</td>
              <td>{{ $t("table.error_message") }}</td>
            </tr>
          </tbody>
        </table>

        <button class="btn02">Sucesso</button>

        <pre>
      <code class="language-json">HTTP/1.1 200 OK
[
{
 "scheduled_at": "2021-07-05 08:32:55",
 "from": "Default",
 "messages": [
   {
      "id": "b4e1d77a69c585c570c7d77782ddb329",
      "from": "Default",
      "to": "5561996426188",
      "content": "{\"content\":\"Teste\"}",
      "account_id": "3d223457-9fd0-48d1-a7e6-bee520ec055c",
      "direction": "outbound",
      "status": "accepted",
      "channel": "rcs",
      "type": "text",
      "client_id": "6460b274-d764-49aa-9889-0e8272bb62e6",
      "scheduled_at": "2021-07-05 08:32:55",
      "is_scheduled": false,
      "updated_at": "2021-07-05 08:32:55",
      "created_at": "2021-07-05 08:32:55",
      "sent_at": "2021-07-05 08:32:55",
      "error_code": null,
      "error_message": null
   }
 ]
}
]</code>
    </pre>

        <button class="btn02">Error-Response</button>
        <pre>
      <code class="language-json">{
"error": "Error message"
}</code>
    </pre>
      </div>
    </section>

    <section id="api-RCS-PutRcsTemplate">
      <h2>RCS - {{ $t("title.update_template") }}</h2>
      <p>{{ $t("general.update_template_method") }}</p>
      <div class="">
        <div class="post type">PUT</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/rcs/templates/:template_id</code></pre>
      </div>
      <div class="code-toggle">
        <button class="json">JSON</button>
        <pre>
          <code class="language-json">{{ updateTemplateJson }}</code>
        </pre>

        <h3>{{ $t("general.parameter") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>name</td>
              <td>String</td>
              <td>{{ $t("table.template_name") }}</td>
            </tr>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.message_type-rcs") }}</td>
            </tr>
            <tr>
              <td>body</td>
              <td>Object</td>
              <td>{{ $t("table.message_body_object") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Body</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.message_text_content") }}</td>
            </tr>
            <tr>
              <td>media</td>
              <td>Object</td>
              <td>{{ $t("table.media") }}</td>
            </tr>
            <tr>
              <td>card</td>
              <td>Object</td>
              <td>{{ $t("table.card_object") }}</td>
            </tr>
            <tr>
              <td>carousel</td>
              <td>Object</td>
              <td>{{ $t("table.carousel_items_object") }}</td>
            </tr>
            <tr>
              <td>suggestions[]</td>
              <td>Array</td>
              <td>{{ $t("table.body.suggestions") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Card</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>title</td>
              <td>String</td>
              <td>{{ $t("table.card_title") }}</td>
            </tr>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.card_text") }}</td>
            </tr>
            <tr>
              <td>media</td>
              <td>Object</td>
              <td>{{ $t("table.card_media") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>{{ $t("table.carousel") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>buttons</td>
              <td>Array</td>
              <td>{{ $t("table.buttons_array") }}</td>
            </tr>
            <tr>
              <td>cards</td>
              <td>Array</td>
              <td>{{ $t("table.card_objects_array") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Button</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.button_type") }}</td>
            </tr>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.button_text") }}</td>
            </tr>
            <tr>
              <td>phone_number</td>
              <td>String</td>
              <td>{{ $t("table.dial_button_number") }}</td>
            </tr>
            <tr>
              <td>address</td>
              <td>String</td>
              <td>{{ $t("table.location_address") }}</td>
            </tr>
            <tr>
              <td>url</td>
              <td>String</td>
              <td>{{ $t("table.button_link") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Suggestions</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.button_type") }}</td>
            </tr>
            <tr>
              <td>text</td>
              <td>String</td>
              <td>{{ $t("table.button_text") }}</td>
            </tr>
            <tr>
              <td>phone_number</td>
              <td>String</td>
              <td>{{ $t("table.dial_button_number") }}</td>
            </tr>
            <tr>
              <td>address</td>
              <td>String</td>
              <td>{{ $t("table.location_address") }}</td>
            </tr>
            <tr>
              <td>url</td>
              <td>String</td>
              <td>{{ $t("table.button_link") }}</td>
            </tr>
            <tr>
              <td>title</td>
              <td>String</td>
              <td>{{ $t("table.suggestions.title") }}</td>
            </tr>
            <tr>
              <td>start_time</td>
              <td>Date</td>
              <td>{{ $t("table.suggestions.start_time") }}</td>
            </tr>
            <tr>
              <td>end_time</td>
              <td>Date</td>
              <td>{{ $t("table.suggestions.end_time") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Webhook</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>url</td>
              <td>String</td>
              <td>{{ $t("table.webhook_url") }}</td>
            </tr>
            <tr>
              <td>headers</td>
              <td>Object</td>
              <td>{{ $t("table.request_header") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Success 200</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>scheduled_at</td>
              <td>String</td>
              <td>{{ $t("table.scheduled_send_datetime") }}</td>
            </tr>
            <tr>
              <td>from</td>
              <td>String</td>
              <td>{{ $t("table.message_sender") }}</td>
            </tr>
            <tr>
              <td>messages</td>
              <td>Array</td>
              <td>{{ $t("table.messages_to_send") }}</td>
            </tr>
            <tr>
              <td>id</td>
              <td>String</td>
              <td>{{ $t("table.message_id") }}</td>
            </tr>
            <tr>
              <td>to</td>
              <td>String</td>
              <td>{{ $t("table.message_recipient") }}</td>
            </tr>
            <tr>
              <td>content</td>
              <td>String</td>
              <td>{{ $t("table.message_content") }}</td>
            </tr>
            <tr>
              <td>account_id</td>
              <td>String</td>
              <td>{{ $t("account.account_id") }}</td>
            </tr>
            <tr>
              <td>direction</td>
              <td>String</td>
              <td>{{ $t("table.message_direction") }}</td>
            </tr>
            <tr>
              <td>status</td>
              <td>String</td>
              <td>{{ $t("table.send_status") }}</td>
            </tr>
            <tr>
              <td>channel</td>
              <td>String</td>
              <td>{{ $t("table.sending_channel") }}</td>
            </tr>
            <tr>
              <td>type</td>
              <td>String</td>
              <td>{{ $t("table.shipping_type") }}</td>
            </tr>
            <tr>
              <td>client_id</td>
              <td>String</td>
              <td>{{ $t("table.client_id") }}</td>
            </tr>
            <tr>
              <td>is_scheduled</td>
              <td>Boolean</td>
              <td>{{ $t("table.scheduled_message") }}</td>
            </tr>
            <tr>
              <td>updated_at</td>
              <td>String</td>
              <td>{{ $t("table.update_datetime") }}</td>
            </tr>
            <tr>
              <td>created_at</td>
              <td>String</td>
              <td>{{ $t("table.creation_datetime") }}</td>
            </tr>
            <tr>
              <td>sent_at</td>
              <td>String</td>
              <td>{{ $t("table.sending_datetime") }}</td>
            </tr>
            <tr>
              <td>error_code</td>
              <td>String</td>
              <td>{{ $t("table.error_code") }}</td>
            </tr>
            <tr>
              <td>error_message</td>
              <td>String</td>
              <td>{{ $t("table.error_message") }}</td>
            </tr>
          </tbody>
        </table>

        <button class="btn02">Sucesso</button>

        <pre>
      <code class="language-json">HTTP/1.1 200 OK
[
{
 "scheduled_at": "2021-07-05 08:32:55",
 "from": "Default",
 "messages": [
   {
      "id": "b4e1d77a69c585c570c7d77782ddb329",
      "from": "Default",
      "to": "5561996426188",
      "content": "{\"content\":\"Teste\"}",
      "account_id": "3d223457-9fd0-48d1-a7e6-bee520ec055c",
      "direction": "outbound",
      "status": "accepted",
      "channel": "rcs",
      "type": "text",
      "client_id": "6460b274-d764-49aa-9889-0e8272bb62e6",
      "scheduled_at": "2021-07-05 08:32:55",
      "is_scheduled": false,
      "updated_at": "2021-07-05 08:32:55",
      "created_at": "2021-07-05 08:32:55",
      "sent_at": "2021-07-05 08:32:55",
      "error_code": null,
      "error_message": null
   }
 ]
}
]</code>
    </pre>

        <button class="btn02">Error-Response</button>
        <pre>
      <code class="language-json">{
"error": "Error message"
}</code>
    </pre>
      </div>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "RcsComponent",
  data() {
    return {
      selectedTab: "json",
      json: {
        agent_id: "00000000-0000-0000-0000-000000000000",
        data: [
          {
            to: "5511999999999",
            type: "text|media|card|carousel|template",
            body: {
              template_id: "00000000-0000-0000-0000-000000000000",
              text: "hello world",
              media: {
                url: "http://teste.com",
              },
              card: {
                title: "Title",
                text: "Hello World",
                media: {
                  url: "http://teste.com",
                },
                buttons: [
                  {
                    type: "reply|dial|location|event|url",
                    text: "text",
                    phone_number: 5511999999999,
                    address:
                      "Av. São João, 473 - Loja 03 - Centro, Peruíbe - SP, 11750-000",
                    url: "https://url.com/",
                  },
                ],
              },
              carousel: {
                cards: [
                  {
                    title: "Title",
                    text: "Hello World",
                    media: {
                      url: "http://teste.com",
                    },
                    buttons: [
                      {
                        type: "reply|dial|location|event|url",
                        text: "text",
                        phone_number: 5511999999999,
                        address:
                          "Av. São João, 473 - Loja 03 - Centro, Peruíbe - SP, 11750-000",
                        url: "https://url.com/",
                      },
                    ],
                  },
                ],
              },
              suggestions: [
                {
                  type: "reply|dial|url|location|event",
                  text: "buttontext",
                  phone_number: "5511999999999",
                  url: "https://www.url.com/",
                  address: "nomedolocal",
                  title: "Event Name",
                  start_time: "2025-07-01 00:00",
                  end_time: "2025-07-03 23:59",
                },
              ],
            },
            webhook: {
              url: "https://url.com",
              headers: {
                Authorization: "Basic 1234",
              },
            },
          },
        ],
      },
      templateResponseJson: {
        id: "00000000-0000-0000-0000-000000000000",
        account_id: "11111111-1111-1111-1111-111111111111",
        name: "Example Template",
        type: "text",
        body: {
          text: "This is a sample template text",
        },
        created_at: "2024-01-01T00:00:00.000000Z",
        updated_at: "2024-01-01T00:00:00.000000Z",
      },
      createTemplateJson: {
        name: "Example Template",
        type: "text|media|card|carousel",
        body: {
          text: "Welcome to our product showcase",
          media: {
            url: "https://example.com/placeholder-image.jpg",
          },
          card: {
            title: "Featured Product",
            text: "Check out our latest offerings",
            media: {
              url: "https://example.com/product-image.jpg",
            },
            buttons: [
              {
                type: "reply|dial|location|event|url",
                text: "Learn More",
                phone_number: 5511912345678,
                address: "123 Example Street, Sample City, ST 12345",
                url: "https://example.com/product",
              },
            ],
          },
          carousel: {
            cards: [
              {
                title: "Product One",
                text: "First amazing product description",
                media: {
                  url: "https://example.com/product1.jpg",
                },
                buttons: [
                  {
                    type: "reply|dial|location|event|url",
                    text: "View Details",
                    phone_number: 5511912345678,
                    address: "123 Example Street, Sample City, ST 12345",
                    url: "https://example.com/product1",
                  },
                ],
              },
              {
                title: "Product Two",
                text: "Second amazing product description",
                media: {
                  url: "https://example.com/product2.jpg",
                },
                buttons: [
                  {
                    type: "reply|dial|location|event|url",
                    text: "View Details",
                    phone_number: 5511912345678,
                    address: "123 Example Street, Sample City, ST 12345",
                    url: "https://example.com/product2",
                  },
                ],
              },
            ],
          },
          suggestions: [
            {
              type: "reply|dial|location|event|url",
              text: "Contact Sales",
              phone_number: "5511912345678",
              url: "https://example.com/contact",
              address: "Main Store",
              title: "Product Launch Event",
              start_time: "2024-01-01 09:00",
              end_time: "2024-01-01 18:00",
            },
          ],
        },
      },
      updateTemplateJson: {
        name: "Example Template",
        type: "text|media|card|carousel",
        body: {
          text: "Welcome to our product showcase",
          media: {
            url: "https://example.com/placeholder-image.jpg",
          },
          card: {
            title: "Featured Product",
            text: "Check out our latest offerings",
            media: {
              url: "https://example.com/product-image.jpg",
            },
            buttons: [
              {
                type: "reply|dial|location|event|url",
                text: "Learn More",
                phone_number: 5511912345678,
                address: "123 Example Street, Sample City, ST 12345",
                url: "https://example.com/product",
              },
            ],
          },
          carousel: {
            cards: [
              {
                title: "Product One",
                text: "First amazing product description",
                media: {
                  url: "https://example.com/product1.jpg",
                },
                buttons: [
                  {
                    type: "reply|dial|location|event|url",
                    text: "View Details",
                    phone_number: 5511912345678,
                    address: "123 Example Street, Sample City, ST 12345",
                    url: "https://example.com/product1",
                  },
                ],
              },
              {
                title: "Product Two",
                text: "Second amazing product description",
                media: {
                  url: "https://example.com/product2.jpg",
                },
                buttons: [
                  {
                    type: "reply|dial|location|event|url",
                    text: "View Details",
                    phone_number: 5511912345678,
                    address: "123 Example Street, Sample City, ST 12345",
                    url: "https://example.com/product2",
                  },
                ],
              },
            ],
          },
          suggestions: [
            {
              type: "reply|dial|location|event|url",
              text: "Contact Sales",
              phone_number: "5511912345678",
              url: "https://example.com/contact",
              address: "Main Store",
              title: "Product Launch Event",
              start_time: "2024-01-01 09:00",
              end_time: "2024-01-01 18:00",
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-section {
  margin-top: 30px;
  text-align: start;
}

.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
